// extracted by mini-css-extract-plugin
export var columnList = "_hx-0";